import React from 'react';
import facebookIcon from '../../assets/logos/facebook.svg';
import twitterIcon from '../../assets/logos/twitter.svg';
import instagramIcon from '../../assets/logos/instagram.svg';
import linkedinIcon from '../../assets/logos/linkedin.svg';
import youtubeIcon from '../../assets/logos/youtube.svg';
import pinterestIcon from '../../assets/logos/pinterest.svg';
import tiktokIcon from '../../assets/logos/tiktok.svg';
import googleBusinessIcon from '../../assets/logos/google-business.svg';

export type SocialPlatform = 
  | 'facebook'
  | 'twitter'
  | 'instagram'
  | 'linkedin'
  | 'youtube'
  | 'pinterest'
  | 'tiktok'
  | 'google-business';

interface SocialIconProps {
  platform: SocialPlatform;
  className?: string;
  size?: number;
}

const icons: Record<SocialPlatform, string> = {
  facebook: facebookIcon,
  twitter: twitterIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  youtube: youtubeIcon,
  pinterest: pinterestIcon,
  tiktok: tiktokIcon,
  'google-business': googleBusinessIcon
};

export const SocialIcon: React.FC<SocialIconProps> = ({ 
  platform, 
  className = '', 
  size = 24 
}) => {
  const iconSrc = icons[platform];
  
  if (!iconSrc) {
    return null;
  }

  return (
    <img 
      src={iconSrc} 
      alt={`${platform} icon`}
      className={className}
      style={{ width: size, height: size }}
    />
  );
};

// Helper to normalize various platform strings to our canonical SocialPlatform
export const normalizePlatformName = (input: string): SocialPlatform => {
  const raw = (input || '').toString().trim().toLowerCase();
  if (!raw) return 'twitter';
  // Map X/Twitter variants to twitter
  if (['x', 'x.com', 'x-twitter', 'x_twitter', 'twitter', 'tw'].includes(raw)) return 'twitter';
  // Normalize google business naming variants
  if (['googlebusiness', 'google_business', 'google my business', 'google-my-business', 'gmb'].includes(raw)) return 'google-business';
  const allowed: SocialPlatform[] = ['facebook','twitter','instagram','linkedin','youtube','pinterest','tiktok','google-business'];
  const found = allowed.find(p => p === raw);
  return found || 'twitter';
};